import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import { GetdatafirebaseService } from '../../services/getdatafirebase.service';
declare var $: any;
@Component({
  selector: 'app-editplantinfo',
  templateUrl: './editplantinfo.component.html',
  styleUrls: ['./editplantinfo.component.css']
})
export class EditplantinfoComponent implements OnInit, OnDestroy {
  @ViewChild('accessId') accessId: ElementRef;

  AskStory: UntypedFormGroup;
  myzone: any;
  userdata: any;
  selectyear: any;
  supportlist: any;
  constructor(
    private spinner: NgxSpinnerService,
    private auth: Authenticationservice,
    private firebase: GetdatafirebaseService,) {
    this.userdata = this.auth.Authention();
    this.myzone = this.userdata.zonedata;
    /* this.firebase.getYear().then((year: any) => {
       year = year.filter(el => el.active = '1');
       this.selectyear = year;
       console.log('data year: ', year);
     });*/

  }

  canetype = [
    { code: "ER", name: "ปลายฝน" },
    { code: "SR", name: "ต้นฝน" },
    { code: "ST1", name: "ตอ 1" },
    { code: "ST2", name: "ตอ 2" },
    { code: "ST3", name: "ตอ 3" },
    { code: "ST>", name: "> ตอ3" },
    { code: "CL", name: "แปลงเสียหาย" },
    { code: "OT", name: "ยกเลิกมีเบิกปัจจัย" }
  ];

  select_Year = [];
  listYear = [
    [0, 0, '2324', '6667', '2566/2567', '6566'],
    [1, 1, '2425', '6768', '2567/2568', '6667'],
  ];

  async ngOnInit(): Promise<void> {
    await this.firebase.getSVProfile(201, 203).then((splist: any) => {
      splist.sort((a, b) => a.ZoneId.localeCompare(b.ZoneId));
      this.supportlist = splist;
      console.log('data supportlist: ', splist);
    });
    /*await this.firebase.getSVProfile(301, 302).then((splist: any) => {      
      this.supportlist = splist;
      console.log('data supportlist: ', splist);
    });*/

    this.select_Year = this.listYear.filter(el => el[0] == 1)[0];
    console.log(this.listYear, 'select_Year: ', this.select_Year);
    this.LoadZone();
    this.LoadTitle();
    this.LoadlistAsk();
    setTimeout(() => {
      this.goloadfarmerinzone();
    }, 100);
  }

  new_fm: any = {};
  fmcode_f = '';
  async searchFm() {
    let fm = this.fmcode_f.trim();
    await this.firebase.getFmProfile(fm).then((splist: any) => {
      if (splist.length > 0) {
        this.new_fm = splist[0];
        this.not_give = true;
        this.edit_be = [splist[0].code.trim(), splist[0].fName.trim()];
      }
      else {
        this.new_fm = {}; this.not_give = false;
      }
      console.log('data farmer: ', splist[0]);
    });

  }
  // โหลดข้อมูล zone
  zonecode: any;
  LoadZone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
        this.spinner.hide();
      }).catch(err => { throw (err) })
  }

  // โหลดข้อมูลชาวไร่
  famerlist1 = [];
  famerlist2 = [];
  async goloadfarmerinzone() {
    let year = this.select_Year[3]
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_fmcodeIn_cp${year}]('${this.myzone.substring(0, 2)}')&w=1=1`
    this.spinner.show();
    await axios.get(url)
      .then(res => {
        this.spinner.hide();
        let data = res.data;
        if (data.length > 0) {
          this.famerlist1 = data;
          this.famerlist2 = data;
        }
      }).catch(err => { console.log(err); })
  }

  txtFindIn: string;
  search_dataFM() {//กรองข้อความ
    let keyword = (this.txtFindIn.trim()).toLowerCase();
    if (keyword == '') { this.famerlist1 = this.famerlist2; }
    else {
      this.famerlist1 = this.famerlist2.filter((el) => ((el.fmcode_b1.indexOf(keyword) > -1) || (el.fmname.indexOf(keyword) > -1))) || [];
      //if (this.famerlist.length! > 0) this.famerlist = []
    }
  }
  farmer: any = {};
  confirm_d = false;
  edit_type: number;

  // โหลดข้อมูลชาวไร่ 1 คน
  dataonefarmer: any[];
  LoadOnefarmerdata() {
    this.dataonefarmer = [];
    //let year = this.select_Year[2]//this.AskStory.get('year').value;
    let fmcode = this.farmer//((<HTMLInputElement>document.getElementById("codefm")).value).slice(0, 10)
    console.log('data fmcode: ', fmcode);
    if (fmcode.fmcode_b1.length == 0) { alert('เลือกหรือระบุรหัสชาวไร่'); }
    else {
      let year = this.select_Year[3]
      this.spinner.show();
      //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp_data_w?year=" + year + "&fmcode=" + fmcode[0].fmcode_b1;
      let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp${year}_basic_a]&w=[fmcode]='${fmcode.fmcode_b1}'`
      axios.get(url)
        .then(res => {
          this.spinner.hide();
          this.oneselect = [];
          let data = res.data;
          if (data.length > 0) this.dataonefarmer = data;
          else alert('ไม่มีข้อมูลแปลง ในปี ' + year + ' หรือลองค้นหาใหม่');
        }).catch(err => { console.log(err); })
    }
  }
  // โหลดข้อมูลหัวข้อ
  asktitle: any;
  LoadTitle() {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[edit_type]&w=1=1`
    axios.get(url)
      .then(res => {
        this.asktitle = res.data;
      })
      .catch(err => { throw (err) })
  }

  // เลือก 1 แปลง
  oneselect = [];
  Getselectdata(data: any) {
    //let oneplant = this.dataonefarmer.filter((el: any) => el.itid == itid);
    this.oneselect = [data];
    console.log('data oneplant: ', data);
    this.CheckplantcreditandFactor(data.itid);
    this.edit_type = 0;
    this.not_give = false;
    this.confirm_d = false;
  }
  // รายการ 
  zonelist: any[];
  LoadlistAsk() {
    let year = this.select_Year[2]
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_editDataCP]&w=[status]=1and[year]='${year}'and[supzone]='${this.myzone}'`;
    axios.get(url)
      .then(res => {
        let data = res.data.sort((b, a) => a.edit_ID.localeCompare(b.edit_ID));
        this.zonelist = data;
      })
      .catch(err => { throw (err) })
  }

  // โหลด ชาวไร่จาก Code 
  onefamerdata: any[];
  LoadFmdataFromCode() {
    let code = this.AskStory.get('threeonwer_plantnewcode').value;
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_farmer_basic]&w=fmcode_b1=%27" + code + "%27")
      .then(res => {
        let data = res.data;
        data.sort((a, b) => {
          return new Date(b.datepost).getTime() - new Date(a.datepost).getTime();
        });
        this.onefamerdata = data;
        //this.AskStory.get('threeonwer_plantnew').setValue(this.onefamerdata[0].fmname);

      })
      .catch(err => { throw (err) })
  }

  check = true;
  // ตรวจสอบหนี้เกี๊ยวปัจจัย
  checkcreditandfactor: any;
  data_factors = [];
  sum_money_amt = 0;
  CheckplantcreditandFactor(itid: string) {
    let year = this.select_Year[3];//this.AskStory.get('year').value;
    let fmcode = this.farmer
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dataIntech/ck_factors?itid=${itid}`
    axios.get(url).then(res => {
      let data = res.data;
      this.sum_money_amt = 0
      this.data_factors = data;
      this.sum_money_amt = data.reduce((total, item) => total + item.money_amt, 0);
      //this.openmodel();
    });
  }

  edit_be = [];
  edit_data = { edit_type: 0, edit_from: '', edit_code_to: '', edit_to: '', comment: '' }
  // ส่งคำขอ
  SendAsk() {
    let ed = this.edit_data;
    let dt = this.oneselect[0];
    let usd = this.userdata;
    // ยกเลิกแปลง

    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_editDataCP?edit_type=${ed.edit_type}
        &itid='${dt.itid}'
        &edit_from='${this.old_value}'
        &edit_code_to='${this.edit_be[0]}'
        &edit_to='${this.edit_be[1]}'        
        &year=${this.select_Year[2]}
        &comment='${ed.comment}'
        &supzone='${usd.zonedata}'
        &supcode='${usd.supcode}'`;

    url = url.replace(/\n\s*/g, '\n');
    console.log(url);
    if (confirm("ต้องการบันทึกข้อมูล")) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("ส่งเรื่องสำเร็จ");
            this.oneselect = [];
            this.LoadlistAsk();
            this.check = true;
          }
          else alert("!!! ส่งเรื่องไม่สำเร็จ กรุณาลองใหม่!!!");
        })
        .catch(err => { throw (err) })
    }
  }

  old_value: string;
  not_give = false;
  // เลือกฟอร์มสำหรับใช้คำขอแต่ละอย่าง
  SwapForm() {
    this.confirm_d = false;
    this.edit_data.comment = '';
    let onesel = this.oneselect;
    let edate = this.edit_data;
    let title = edate.edit_type = this.edit_type;//this.AskStory.get('title').value;
    let old_val = '';
    let money_amt = this.sum_money_amt

    if (title == 1) {//ขอยกเลิกแปลงอ้อย
      if (money_amt > 0) {
        alert('แปลงนี้ไม่สามารถขอยกเลิกได้ เนื่องจากมีรายการขอเกี๊ยวคงค้าง หรือ รายการเบิกปัจจัยค้าง');
        this.not_give = false;
      }
      else this.not_give = true;
    }
    else if (title == 2) {//ขอแก้ไขประเภทอ้อย
      this.not_give = false;
      old_val = onesel[0].CaneTypeName;
    }
    else if (title == 3) {//ขอแก้ไขเจ้าของแปลงอ้อย
      this.not_give = false;
      old_val = onesel[0].fmname;
    }
    else if (title == 4) {//ขอแก้ไขโซน
      this.not_give = false;
      old_val = onesel[0].supzone;
    }
    else if (title == 5) {//ขอแก้ไขกรรมสิทธิ์แปลง
      this.not_give = false;
      old_val = onesel[0].plotdesc;
    }
    else if (title == 6) {//ขอแก้ไขนักส่งเสริม ผู้ดูแลแปลงอ้อย
      this.not_give = false;
      old_val = onesel[0].supname;
    }
    this.edit_data = edate;
    this.old_value = old_val;
  }
  // ยกเลิกคำขอที่ส่งเข้า
  CancleEdit(id: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/canceled_editDataCP?edit_ID=" + id;
    if (confirm("ต้องการยกเลิกรายการนี้หรือไม่ ?") == true) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("ยกเลิกคำขอสำเร็จ");
            this.LoadlistAsk();
          }
          else { alert("!!! ยกเลิกคำขอไม่สำเร็จ กรุณาลองใหม่!!!"); }
        })
        .catch(err => { throw (err) })
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.oneselect = null;
    this.zonelist = null;
    this.dataonefarmer = null;
    this.famerlist1 = null;
    this.famerlist2 = null;
    this.asktitle = null;
    this.onefamerdata = null;
    this.myzone = null;
    this.userdata = null;
    this.selectyear = null;
    this.supportlist = null;
  }
}